








import Vue from 'vue'
import ActionButton from '@/components/ActionButton.vue'

export default Vue.extend({
  components: {
    appActionButton: ActionButton,
  },
})
